<template>
  <div class="page-gallery">
    <div
      class="page-header header-accent-gradient card-base card-shadow--small"
    >
      <h1>Galeria</h1>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }"
          ><i class="mdi mdi-home-outline"></i
        ></el-breadcrumb-item>
        <!-- TODO poner idioma aqui -->
        <!--  -->
        <el-breadcrumb-item>Home</el-breadcrumb-item>
        <el-breadcrumb-item>Gallery</el-breadcrumb-item>
        <el-breadcrumb-item>Social</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="flex justify-flex-end">
        <!-- <h4>
          All pictures taken from
          <a href="https://pexels.com/" target="_blank" class="white-text"
            >pexels.com</a
          >
        </h4> -->
        <el-button type="primary" round icon="el-icon-plus" @click="add = true">
          Crear album</el-button
        >
      </div>
    </div>
    <div id="container">
      <el-drawer
        title="Nuevo Album"
        size="50%"
        direction="rtl"
        :visible.sync="add"
        :with-header="true"
      >
        <newAlbum
          @close="add = false"
          :albumType="0"
          @success="handleSuccess"
        ></newAlbum>
      </el-drawer>
      <ItemList v-loading="loading" :items="albums" @delete="handleDelete" />
      <h1 v-if="albums.length === 0">No hay album creado</h1>
    </div>
    <div class="photo-list"></div>
  </div>
</template>

<script>
import newAlbum from "./NewAlbum";
import ItemList from "./GalleryItemList";

const TYPE_ALBUM_SOCIAL = 0;

export default {
  name: "GallerySocial",

  data() {
    return {
      add: false,
      loading: true,
      albums: []
    };
  },
  mounted() {
    this.getAlbumList();
  },
  components: {
    newAlbum,
    ItemList
  },
  methods: {
    handleDelete() {
      this.loading = true;
      this.getAlbumList();
    },
    getAlbumList() {
      const api = `/api/gallery/Albums`;
      this.$http
        .get(api, {
          params: {
            albumType: TYPE_ALBUM_SOCIAL,
            company: this.currentCompany
          }
        })
        .then((response) => {
          this.albums = response.data;
          this.loading = false;
        })
        .catch((e) => {
          this.$message({ message: e, type: "error" });
          this.loading = false;
        });
    },
    handleSuccess() {
      this.getAlbumList();
    }
  }
};
</script>

<style lang="scss" scoped>
/*.photo-list {
	//padding: 20px;
}*/
</style>
